import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SessionService } from "@app/shared/services/session.service";

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    host: {
        class: 'app-landing'
    },
    providers: [DatePipe],
    standalone: false
})
export class LandingComponent implements OnInit {

  isLoading: boolean = false;
	module: string = '';

	constructor(
		public session: SessionService,
		public router: Router) {
	}

	async ngOnInit(): Promise<void> {

		const user = await this.session.getUser();
		if (!user) {
			this.router.navigateByUrl('login');
		}
	}

}
